/**
 * 식장 방문 목록 일괄 비용 문의 Hackle A/B (conversion-squad 액션 003).
 * Control(A)=칩 없음 · Treatment(B)=찾아보신 N곳 비용 알아보기 · 50:50.
 * 할당은 서로 다른 식장 2곳 이상일 때만 (ParlorMultiSplitContainer).
 */
export const PARLOR_VISITED_LIST_EXPERIMENT_KEY = 334;

export function isVisitedListTreatment(variation: string): boolean {
  return variation === "B";
}
